import { classes } from 'html-classes';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import Icon from '~/components/Icon/Icon';
import Modal from '~/components/Modal/Modal';
import { useGlobal } from '~/hooks/useGlobal';
import { useModal } from '~/hooks/useModal';
import TransactionItem from '~/pages/LoyaltyProgram/components/History/TransactionItem';
import { userStore } from '~/stores';

import styles from './ModalTransactionDetails.module.scss';

const ModalTransactionDetails = () => {
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();
  const { closeModal } = useModal();
  const { isMobile } = useGlobal();
  const transactionId = searchParams.get('transactionId');

  const transaction =
    userStore.loyaltyPointsStore.loyaltyPointsTransactionsList.find(
      (t) => t.id === transactionId,
    );

  const handleCloseModal = () => {
    closeModal(['transactionId']);
  };

  if (!transaction) {
    return null;
  }

  return (
    <Modal
      isShow={true}
      className={styles.transactionDetails}
      onBackdropDismiss={handleCloseModal}
    >
      <div className={styles.transactionDetails__container}>
        <div className={styles.transactionDetails__header}>
          <h3>{t('loyalty:progress:modalTransactionDetails:title')}</h3>
          <button className={styles.closeButton} onClick={handleCloseModal}>
            <Icon type="close" size={isMobile ? 24 : 32} />
          </button>
        </div>
        <div className={styles.transactionDetails__body}>
          {transaction.order && (
            <TransactionItem
              as="div"
              transaction={transaction}
              className={styles.transactionItem}
            />
          )}

          <div className={styles.reasonsSection}>
            <p className={styles.reasonsSection__intro}>
              {t('loyalty:progress:modalTransactionDetails:returnReasonIntro')}
              <ul className={styles.reasonsList}>
                {[
                  'loyalty:progress:modalTransactionDetails:reasonCanceledOrder',
                  'loyalty:progress:modalTransactionDetails:reasonPaymentFailed',
                  'loyalty:progress:modalTransactionDetails:reasonOutOfStock',
                  'loyalty:progress:modalTransactionDetails:reasonOrderReturned',
                ].map((reasonKey) => (
                  <li key={reasonKey}>{t(reasonKey)}</li>
                ))}
              </ul>
              <br />
              {t('loyalty:progress:modalTransactionDetails:supportContact')}
            </p>
          </div>
        </div>
        <div className={styles.transactionDetails__footer}>
          <button
            type="button"
            className={classes(['button', '_primary', '_med', styles.okButton])}
            onClick={handleCloseModal}
          >
            {t('okButton')}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default observer(ModalTransactionDetails);
